/**
 * Plan tier from a plan key. Browser-safe (exported from
 * `@repo/payments/client`); `plan-detection` re-exports it for the server.
 *
 * A tier groups the plan generations a subscriber can hold for the same rung
 * of the ladder: v1 Brand and v2 Brand are both "brand"; v1 Agency Core (flat
 * or usage-based) and v2 Agency Core are both "core".
 */
export function getPlanTier(planId: string | null | undefined): string | null {
	if (!planId) return null;

	const lowerPlanId = planId.toLowerCase();

	if (lowerPlanId === "brand" || lowerPlanId === "brandv2") return "brand";
	if (lowerPlanId === "enterprise") return "enterprise";

	// Agency plans
	if (
		lowerPlanId === "agencycore" ||
		lowerPlanId === "agency_core" ||
		lowerPlanId === "agencycoreusagebased" ||
		lowerPlanId === "agencycorev2"
	) {
		return "core";
	}
	if (lowerPlanId === "agencypro") return "pro";

	// Legacy plans
	if (lowerPlanId === "core") return "core";
	if (lowerPlanId === "pro") return "pro";
	if (lowerPlanId === "lifetime") return "lifetime";

	return null;
}
